import { CommonTooltips } from "@mcleod/common";
import { Component, Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { Currency, CurrencyUtil, DisplayType, ModelRow } from "@mcleod/core";
import { AutogenLayoutLaneHistoryTable } from "./autogen/AutogenLayoutLaneHistoryTable";

export class LaneHistoryTable extends AutogenLayoutLaneHistoryTable {

    override onLoad(): void | Promise<void> {
        this.tableLaneHistory.overrideUrlParams = (selectedRow: TableRow) => {
            return { key: selectedRow.data.get("id"), orderId: selectedRow.data.get("orders.id") }
        }
    }

    tableLaneHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const modelRow = tableRow.data;
        tableRow.forEveryChildComponent(comp => {
            this.setTooltipContent(comp, modelRow);
        });

        this.setupBuyToMarket(tableRow, modelRow);
        this.toggleTargetPay(tableRow, modelRow);
    }

    toggleTargetPay(tableRow: TableRow, modelRow: ModelRow) {
        const textboxTargetPay = tableRow.findComponentById("textboxTargetPay");
        const overrideTargetPay = modelRow.getCurrency('override_targetpay', new Currency(0));
        if (textboxTargetPay) {
            textboxTargetPay.visible = !modelRow.isNull('target_pay') || overrideTargetPay.isPositive();
            const labelTargetPay = tableRow.findComponentById("labelTargetPay") as Label;
            if (labelTargetPay) {
                labelTargetPay.visible = textboxTargetPay.visible;
            }
        }

        const textboxOverridePay = tableRow.findComponentById('textboxOverridePay');
        if (textboxOverridePay) {
            textboxOverridePay.visible = textboxTargetPay.visible && overrideTargetPay.isPositive();
            const labelOverridePay = tableRow.findComponentById('labelOverridePay')
            if (labelOverridePay) {
                labelOverridePay.visible = textboxOverridePay.visible;
            }
        }
    }

    setupBuyToMarket(tableRow: TableRow, modelRow: ModelRow) {
        const labelBtmCalc = tableRow.findComponentById("labelBtmCalc") as Label;
        if (labelBtmCalc) {
            const btmUnderMarket = modelRow.isNull('btm_calc') || !modelRow.getCurrency('btm_calc').isPositive();
            labelBtmCalc.color = btmUnderMarket ? 'success' : 'error';

            if (!btmUnderMarket) {
                labelBtmCalc.text = `OVER ${labelBtmCalc.text}`;
            }
        }
    }

    setTooltipContent(comp: Component, modelRow: ModelRow) {
        if (comp.id == null) return;
        switch (comp.id) {
            case "labelCarrierName":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("payee.id"), "lme/powerbroker/CarrierQuickInfo", {
                    minWidth: 128,
                    minHeight: 140
                });
            case "labelCarrierNamePrimary":
            case "labelCarrierNameSecondary":
            case "labelCarrierNameThird":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("override_payee_id"), "lme/powerbroker/CarrierQuickInfo", {
                    minWidth: 128,
                    minHeight: 140
                });
            case "labelCustomerName":
            case "labelCustomerNamePrimary":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("customer.id"), "lme/ar/CustomerQuickInfo", {
                    minWidth: 128,
                    minHeight: 140
                });
            case "labelTotalCharge":
                const freightCharge = modelRow.get("prorated_move.prorated_revenue", modelRow.get("orders.freight_charge"));
                const otherCharges = modelRow.get("prorated_move.prorated_oc", modelRow.get("orders.otherchargetotal"));
                return CommonTooltips.setTooltipContentTextboxes(comp, () => [
                    {
                        caption: "Freight Charge",
                        displayType: DisplayType.CURRENCY,
                        text: CurrencyUtil.formatCurrency(freightCharge)
                    },
                    {
                        caption: "Other Charges",
                        displayType: DisplayType.CURRENCY,
                        text: CurrencyUtil.formatCurrency(otherCharges)
                    }]
                );
            case "labelTotalPay":
                return CommonTooltips.setTooltipContentTextboxes(comp, () => [
                    {
                        caption: "Carrier Pay",
                        displayType: DisplayType.CURRENCY,
                        text: CurrencyUtil.formatCurrency(modelRow.get("override_pay_amt"))
                    },
                    {
                        caption: "Pay Adjustments",
                        displayType: DisplayType.CURRENCY,
                        text: CurrencyUtil.formatCurrency(modelRow.get("other_pay"))
                    }]
                );
        }
    }
}
